/* =========================================================
   JUGO slide-out cart drawer controller.
   Content is SERVER-RENDERED in the global `twmp-cart-drawer` section, so:
   - opening is instant (no fetch)
   - quantity / remove / sub-switch re-render via twmp-cart.js (Section API,
     one request, works on every page — no reload, no /cart fetch)
   - add-to-cart (native forms + external AJAX) re-renders the drawer section
     and opens it, never navigating to /cart
   The full /cart page is bounced into the drawer (no-JS sees the page).
   ========================================================= */
(function () {
  'use strict';

  function drawerEl() { return document.getElementById('twmp-cart-drawer'); }
  function bodyEl() { var d = drawerEl(); return d ? d.querySelector('[data-twmp-drawer-body]') : null; }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function previewParam() {
    try { var p = new URLSearchParams(window.location.search).get('preview_theme_id'); return p ? 'preview_theme_id=' + encodeURIComponent(p) : ''; }
    catch (e) { return ''; }
  }
  // Drawer is DESKTOP only. On mobile (<=989px, where the hamburger shows) the
  // cart is the full-width /cart page — native behavior, no drawer.
  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function open() {
    var d = drawerEl(); if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    var d = drawerEl(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function swapDrawerHTML(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('cart-items');
    var body = bodyEl();
    if (!fresh || !body) return;
    var cur = body.querySelector('cart-items');
    if (cur) { cur.replaceWith(fresh); } else { body.innerHTML = ''; body.appendChild(fresh); }
  }
  function updateCount() {
    fetch(root() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.setAttribute('data-empty', c.item_count === 0 ? 'true' : 'false');
      });
    }).catch(function () {});
  }
  // Re-render the drawer section (used after external AJAX adds we don't control).
  function refreshAndOpen() {
    var url = window.location.pathname + '?sections=twmp-cart-drawer';
    var pv = previewParam(); if (pv) url += '&' + pv;
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (json) { if (json && json['twmp-cart-drawer']) swapDrawerHTML(json['twmp-cart-drawer']); open(); updateCount(); })
      .catch(function () { open(); });
  }

  function cartPath() { return ((window.routes && window.routes.cart_url) || '/cart').replace(/\/+$/, ''); }
  function onCartRoute() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return path === cartPath() || /\/cart$/.test(path);
  }
  function isCartLink(a) {
    if (!a) return false;
    var href = a.getAttribute('href');
    if (!href || /^(mailto:|tel:|#|javascript:)/i.test(href)) return false;
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return false;
      var path = u.pathname.replace(/\/+$/, '');
      return path === cartPath() || /\/cart$/.test(path);
    } catch (e) { return /\/cart\/?($|[?#])/i.test(href); }
  }
  function isAddForm(form) {
    if (!form || form.closest('product-form')) return false;
    if (form.hasAttribute('data-cart-form')) return true;
    return /\/cart\/add/i.test(form.getAttribute('action') || '');
  }
  // 6-jar order cap: jar units per product handle (singles = 1, fixed bundles
  // = their jar contents). Mirrors the map in twmp-cart-contents.liquid.
  var JAR_UNITS = {
    'jugo-acv-superfoods-gummies': 1,
    'jugo-beauty-superfoods-gummies': 1,
    'jugo-energy-superfoods-gummies': 1,
    'jugo-focus-superfoods-gummies': 1,
    'jugo-kids-daily-superfoods': 1,
    'jugo-kids-sport-superfoods': 1,
    'jugo-starter-gummy-bundle': 4,
    'family-bundle': 3,
    'case-of-the-mondays-gummies': 2,
    'fan-favorites-bundle-gummies': 2
  };
  var JAR_CAP = 6;
  function jarUnitsInCart(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { n += (JAR_UNITS[it.handle] || 0) * it.quantity; });
    return n;
  }

  // AJAX a native add-to-cart form (so it never navigates to /cart).
  function addViaForm(form) {
    var fd = new FormData(form);
    fd.append('sections', 'twmp-cart-drawer');
    fd.append('sections_url', window.location.pathname);
    window.__twmpInternalAdd = 1;
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.sections && json.sections['twmp-cart-drawer']) swapDrawerHTML(json.sections['twmp-cart-drawer']);
        open(); updateCount();
      })
      .catch(function () {})
      .finally(function () { window.__twmpInternalAdd = 0; });
  }

  // Gate a jar-product add on the cap before posting. Fails open on fetch errors
  // (the cart banner + disabled checkout is the hard stop either way).
  function addViaFormCapped(form) {
    var perUnit = parseInt(form.getAttribute('data-jar-units') || '0', 10);
    if (!perUnit) { addViaForm(form); return; }
    var qty = parseInt(new FormData(form).get('quantity') || '1', 10) || 1;
    fetch(root() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (jarUnitsInCart(cart) + perUnit * qty > JAR_CAP) {
          open();
          if (window.twmpCapNotice) window.twmpCapNotice();
        } else {
          addViaForm(form);
        }
      })
      .catch(function () { addViaForm(form); });
  }

  /* ---- interactions ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-twmp-drawer-close]')) { e.preventDefault(); close(); return; }
    var link = e.target.closest('a[href]');
    if (link && isCartLink(link)) { if (isDesktop()) { e.preventDefault(); open(); } return; } // mobile: native nav to /cart
    var d = drawerEl();
    if (d && d.classList.contains('is-open') && e.target.closest('.twmp-drawer') && !e.target.closest('.twmp-drawer__panel')) { close(); }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.nodeName === 'FORM' && isAddForm(f) && isDesktop()) { e.preventDefault(); addViaFormCapped(f); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) close(); });

  /* ---- external AJAX adds (e.g. Dawn <product-form>) → refresh + open ---- */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var p = origFetch.apply(this, args);
      try {
        var url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
        if (/\/cart\/add(\.js)?($|[?#])/.test(url) && !window.__twmpInternalAdd && isDesktop()) {
          p.then(function (r) { try { if (r && r.ok) refreshAndOpen(); } catch (e) {} }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* ---- the full /cart page is categorically the drawer ---- */
  if (onCartRoute() && isDesktop() && !(window.Shopify && window.Shopify.designMode)) {
    try { sessionStorage.setItem('twmpOpenCart', '1'); } catch (e) {}
    var dest = root(); var pv = previewParam(); if (pv) dest += (dest.indexOf('?') > -1 ? '&' : '?') + pv;
    window.location.replace(dest);
    return;
  }
  try { if (isDesktop() && sessionStorage.getItem('twmpOpenCart')) { sessionStorage.removeItem('twmpOpenCart'); open(); } } catch (e) {}
})();
